/**
 * 安全构造 RTCIceCandidate，避免 sdpMid/sdpMLineIndex 同时为 null 时报错
 */
export function safeIceCandidate(
  candidate: string,
  sdpMid?: string | null,
  sdpMLineIndex?: number | null
): RTCIceCandidate {
  const init: RTCIceCandidateInit = { candidate }
  if (sdpMid != null && sdpMid !== '') {
    init.sdpMid = sdpMid
  }
  if (sdpMLineIndex != null) {
    init.sdpMLineIndex = sdpMLineIndex
  }
  return new RTCIceCandidate(init)
}

/**
 * 从 WebSocket URL 推导 HTTP 基地址
 * wss://host/ws → https://host
 * ws://host/ws → http://host
 */
export function wsUrlToHttpBase(wsUrl: string): string {
  const url = new URL(wsUrl)
  const protocol = url.protocol === 'wss:' ? 'https:' : 'http:'
  return `${protocol}//${url.host}`
}

/**
 * 从 ICE candidate 字符串中提取 IP 地址
 * 格式: candidate:<foundation> <component> <protocol> <priority> <ip> <port> <type> [extra]
 */
export function extractIPFromCandidate(candidate: string): string {
  const fields = candidate.split(/\s+/)
  if (fields.length >= 5) {
    return fields[4]
  }
  return ''
}

/**
 * 判断 IP 是否为内网地址
 * 支持: 10.x.x.x, 172.16-31.x.x, 192.168.x.x, 127.x.x.x, 0.x.x.x
 * 注意：仅适用于 localhost/内网调试场景（浏览器 host candidate 为真实 IP）。
 * 公网 HTTPS 下浏览器发送 mDNS（.local）候选，此函数返回 false 不做过滤，
 * 对 SFU 无影响（mDNS 候选无法被 SFU 解析，ICE 会自动忽略）。
 */
export function isPrivateIP(ip: string): boolean {
  const parts = ip.split('.')
  if (parts.length !== 4) return false
  const nums = parts.map(Number)
  if (nums.some(n => isNaN(n))) return false
  // 10.0.0.0/8
  if (nums[0] === 10) return true
  // 172.16.0.0/12
  if (nums[0] === 172 && nums[1] >= 16 && nums[1] <= 31) return true
  // 192.168.0.0/16
  if (nums[0] === 192 && nums[1] === 168) return true
  // 127.0.0.0/8
  if (nums[0] === 127) return true
  // 0.0.0.0/8
  if (nums[0] === 0) return true
  return false
}
